import type { AsyncData } from "nuxt/app";

export interface SiteBanner {
  uuid: string;
  imageUrl: string | null;
  altText: string;
}

interface SiteBannersResponse {
  data: SiteBanner[];
}

export const useSiteBanners = (): AsyncData<SiteBanner[], Error | null> => {
  const { $customFetch } = useNuxtApp();

  return useAsyncData("home:site-banners", async () => {
    try {
      const response = await $customFetch<SiteBannersResponse>(
        "/public-site-banners",
        { method: "GET" },
      );

      return response.data;
    } catch {
      // Failed request falls back to an empty list so the hero renders its
      // bundled fallback image instead of a technical error (E1).
      return [];
    }
  });
};
